import { render, staticRenderFns } from "./ObjectTypes.vue?vue&type=template&id=61192c38&scoped=true&"
import script from "./ObjectTypes.vue?vue&type=script&lang=ts&"
export * from "./ObjectTypes.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectTypes.vue?vue&type=style&index=0&id=61192c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61192c38",
  null
  
)

export default component.exports